import { useMutation } from '../';
import { newFunderRating } from '../mutations';

export function useNewFunderRating() {
  const { data, isLoading, mutate } = useMutation();
  
  const run = (variables, onFinish) => {
    mutate(newFunderRating, variables, () => {
      if (typeof onFinish === 'function') {
        onFinish();
      }
    });
  };

  return { data, isLoading, run };
}
